import { render, staticRenderFns } from "./DoKoCurrentTrick.vue?vue&type=template&id=7cbc5c4f&scoped=true&"
import script from "./DoKoCurrentTrick.vue?vue&type=script&lang=ts&"
export * from "./DoKoCurrentTrick.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbc5c4f",
  null
  
)

/* custom blocks */
import block0 from "./DoKoCurrentTrick.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports